import { detect } from 'detect-browser';
import { createContext } from 'react';

function getDataTestId(dataTestId, element) {
    var elementPart = element ? "-".concat(element.toLowerCase()) : '';
    return dataTestId ? "".concat(dataTestId).concat(elementPart) : undefined;
}

detect();

detect();

createContext(function () { return null; });

/* eslint-disable no-console */
if (process.env.NODE_ENV === 'development') ;

export { getDataTestId as g };
